export default "__VITE_ASSET__Cei9teXp__"